import React, { useContext } from "react";
import MenuContainer from "../../components/MenuContainer/index.js";
import logo from "../../images/png/logo_demetra_white.png";
import logo_ntt from "../../images/png/logo_nttdata_white.png";
import { REDIRECT_LOGO } from "../../utils/redirectPaths";
import { Link } from "react-router-dom";
import { Layout, Avatar, Dropdown, Menu } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { AppContext, logout } from "../App";
import "../../css/global.scss"
import ChatPopup from "../ChatBot/ChatPopup.js";

const { Header, Sider, Content } = Layout;

const MainLayout = props => {
  const { children } = props;
  const context = useContext(AppContext);

  const accountMenu = (
    <Menu>
      <Menu.Item key="logout">
        <div onClick={logout}>Logout</div>
      </Menu.Item>
    </Menu>
  )

  const enabledModules = sessionStorage.getItem("enabledModules");
  const isChatBotEnabled = enabledModules && enabledModules.split(",").includes("CHATBOT");


  return (
    <div className="MainLayout">
      <Header
        style={{
          background: "#1a293e",
          borderBottom: "1px solid white",
          position: "fixed",
          padding: "0 25px 0 25px",
          left: 0,
          top: 0,
          right: 0,
          height: 90,
          zIndex: 999,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
        <Link to={REDIRECT_LOGO}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
            <img src={logo} alt="logo" style={{ width: "150px", filter: "brightness(200%)" }} />
            <img src={logo_ntt} alt="logo_ntt" style={{ marginTop: "5px", width: "120px" }} />
          </div>
        </Link>
        <div style={{ display: "flex", alignItems: "center", gap: "10px", color: "#fff" }}>
          <Dropdown overlay={accountMenu} placement="bottom">
            <Avatar
              style={{ backgroundColor: "#3e5364", cursor: "pointer" }}
              icon={<UserOutlined />}
            />
          </Dropdown>
          <div style={{ lineHeight: "1.2" }}>
            <p style={{ margin: 0 }}><b>{context.username}</b></p>
            <p style={{ margin: 0 }}>{context.email}</p>
            <p style={{ margin: 0 }}>{new Date().toDateString()}</p>
          </div>
        </div>
      </Header>
      <Layout>
        <Sider
          width="200px"
          theme="dark"
          style={{
            background: "#335c94",
            borderRight: "1px solid black",
            overflow: "auto",
            height: "100vh",
            position: "fixed",
            left: 0,
            top: 90,
            marginRight: 5,
            zIndex: 1
          }}
        >
          <MenuContainer />
        </Sider>
        <Layout style={{ marginLeft: 200, padding: "0 5px", background: "#fff", display: "flex" }}>
          <Content
            style={{
              background: "#fff",
              marginTop: 100,
              padding: "2rem",
              minHeight: "calc(100vh - 90px)", // altezza header
              overflow: "auto"
            }}>
            {children}
          </Content>
        </Layout>
      </Layout>
      {isChatBotEnabled && <ChatPopup />}
    </div>
  );
};

export default MainLayout;
